
import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { StaticTemplateComponent } from './dashboard/components/static-template.component';
import { PageNotFoundComponent } from './shared/components/not-found.component';
import { AppMaintenanceComponent } from './shared/components/app-maintenance.component';
import { CanActivateNotFoundGuard } from './shared/guards/can-activate-not-found.guard';
import { CanActivateLivePageGuard } from './events/guards/can-activate-live-page.guard';

const appModuleRoutes: Routes = [
  { path: '', component: StaticTemplateComponent },
  { path: 'Aloearoundtheworld', loadChildren: './promotion/promotion.module#PromotionModule' },
  { path: 'foreverlive', loadChildren: './events/events.module#EventsModule', canActivate: [CanActivateLivePageGuard] },
  { path: ':countryName/:languageCode/notfound', component: PageNotFoundComponent },
  { path: ':countryCode/:languageCode/comingsoon', component: AppMaintenanceComponent },
  { path: ':countryName/:languageCode/:slug', component: StaticTemplateComponent },
  { path: '**', component: PageNotFoundComponent, canActivate: [CanActivateNotFoundGuard] }

];

@NgModule({
  imports: [RouterModule.forRoot(appModuleRoutes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
